import {useState} from "react";

export const useModalConfirmAccount = () => {

  const [visibleModalRememberThisDevice, setVisibleModalRememberThisDevice] = useState<boolean>(false);

  return {
    visibleModalRememberThisDevice, setVisibleModalRememberThisDevice
  }
}
